import { actions } from "../../actions/ratings/ratings";

export default function ratings( state, action ) {
    const newState = { ...state }

    switch( action.type ) {
        case actions.GET_RATINGS_SUCCESS: return generalReducer( newState, action );
        case actions.POST_RATINGS_SUCCESS: return generalReducer( newState, action );
        default: return newState;
    }
}

function generalReducer ( state, action ) {
    delete action.type;
    state.ratingCount = action.body;
    return state;
}


// WEBPACK FOOTER //
// src/client/reducers/ratings/ratings.js